export const circularResolutionType="circularResolution"
export const regularMeetingUsePowerOfAttorneyType="regularMeetingUsePowerOfAttorney"
export const minuteReportByFundManagerType="minuteReportByFundManager"